/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 10:53:27
 * @LastEditTime: 2020-09-27 09:43:03
 * @Description: 车辆信息store
 */
import {
  getVehicleByID,
  getVehicleList,
  createVehicle,
  updateVehicle,
  deleteVehicle
} from '@/api/vehicle'
import Vue from 'vue'

const state = {
  vehicleList: [],
  totalCounts: 0
}

const getters = {
  getVehicleById: (state) => (id) => {
    return state.vehicleList.find(x => x._id === id)
  },
}

const actions = {
  async getVehicleListAction({
    commit
  }, payload) {
    try {
      const vehicleList = await getVehicleList(payload);
      commit('SETVEHICLELIST', vehicleList.data)
      return vehicleList.data
    } catch (error) {
      throw error.message
    }
  },
  async getVehicleByIDAction({
    commit
  }, payload) {
    try {
      const vehicle = await getVehicleByID(payload)
      return vehicle.data
    } catch (error) {
      throw error.message
    }
  },
  async createVehicleAction({
    commit
  }, payload) {
    try {
      const vehicle = await createVehicle(payload);
      commit('ADDNEWVEHICLE', vehicle.data)
    } catch (error) {
      throw error.message
    }
  },
  async updateVehicleAction({
    commit
  }, payload) {
    try {
      const vehicle = await updateVehicle(payload.id, payload.data);
      commit('UPDATEVEHICLE', vehicle.data)
    } catch (error) {
      throw error.message
    }
  },
  async deleteVehicleAction({
    commit
  }, payload) {
    try {
      await deleteVehicle(payload)
    } catch (error) {
      throw error.message
    }
  }
}

const mutations = {
  SETVEHICLELIST(state, payload) {
    state.vehicleList = payload.vehicleList;
    state.totalCounts = payload.totalCounts
  },
  ADDNEWVEHICLE(state, vehicle) {
    state.vehicleList.unshift(vehicle)
    state.totalCounts++
  },
  UPDATEVEHICLE(state, vehicle) {
    Vue.set(state.vehicleList, state.vehicleList.findIndex(x => x._id === vehicle._id), vehicle)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}